<template>
  <div class="card-form">
    <EditForm
      class="mb-2"
      ref="editForm"
      :disabled="disabled"
      :hxJdOrderCode="hxJdOrderCode"
    />

    <OrderDetailTable
      class="mb-2"
      ref="skuTable"
      :hxJdOrderCode="hxJdOrderCode"
      :hxShipmentJdCode="hxShipmentJdCode"
    />
  </div>
</template>
<script>
import EditForm from '../components/edit-form'
import OrderDetailTable from '../components/order-detail-table'
export default {
  name: 'ecom-hxBiz-jdOrder-detail',
  components: { EditForm, OrderDetailTable },
  data() {
    return {}
  },
  computed: {
    params() {
      return this.$route.params
    },
    hxJdOrderCode() {
      return this.params.hxJdOrderCode
    },
    hxShipmentJdCode() {
      return this.params.hxShipmentJdCode
    },
    pageType() {
      return this.params.pageType
    },
    disabled() {
      return this.pageType === 'detail'
    },
  },
}
</script>
